export default {
    list: {
        title: 'Zařízení',
        empty: 'Žádná zařízení',
        cols: {
            name: 'Jméno',
            username: 'Username'
        }
    },
    filter: {
        search: 'Hledat (jméno nebo username)'
    },
    actions: {
        newDevice: '+ Nové zařízení'
    },
    form: {
        name: 'Jméno',
        username: 'Přihlašovací jméno',
        password: 'Heslo',
        passwordHint: 'Ponechte prázdné pro zachování stávajícího hesla'
    },
    confirm: {
        deleteTitle: 'Smazat zařízení?',
        deleteBody: 'Opravdu chcete smazat zařízení „{name}"?',
        bulkDeleteTitle: 'Smazat vybraná zařízení?',
        bulkDeleteBody: 'Opravdu chcete smazat {n} zařízení?',
        unsavedChanges: 'Máte neuložené změny. Opravdu zavřít?'
    },
    bulk: {
        selected: '{n} vybráno',
        deleteSelected: 'Smazat vybrané',
        deleteResult: '{ok} smazáno, {failed} selhalo'
    },
    toast: {
        saved: 'Zařízení uloženo',
        deleted: 'Zařízení smazáno'
    },
    qr: {
        title: 'Přihlašovací QR pro zařízení',
        load: 'Načíst QR',
        addToClipboard: 'Přidat do schránky',
        added: 'Přidáno do schránky'
    }
}
